<template>
    <div
        id="checkout"
        class="bg-light"
    >
        <vue-headful :title="pageTitle" />
        <div class="body-wrapper">
            <gallery-header v-if="isStepOrderConfirmed" />
            <header
                role="navigation"
                class="navbar navbar-expand fixed-top navbar-dark"
                v-if="!isStepOrderConfirmed"
            >
                <span class="navbar-brand d-none">
                    <img
                        src="images/logo.png"
                        alt="RikordaEventi"
                    />
                </span>
                <nav>
                    <div class="navbar-nav pulsante-indietro align-items-center text-uppercase">
                        <a
                            class="nav-item nav-link"
                            href=""
                            @click.prevent="navigateSteps()"
                        >
                            <font-awesome-icon :icon="['fas', 'arrow-left']" />&nbsp;
                            <span class="d-none d-md-inline">{{ $t("Indietro") }}</span>
                        </a>
                    </div>
                </nav>
                <div class="text-uppercase d-md-flex justify-content-center">
                    <h5
                        v-if="isStepShippingAddress"
                        class="mb-0"
                    >
                        {{ $t("Completa i tuoi dati") }}
                    </h5>
                    <h5
                        v-if="isStepDeliveryMode"
                        class="mb-0"
                    >
                        {{ $t("Modalità di consegna") }}
                    </h5>
                    <h5
                        v-if="isStepPaymentMode"
                        class="mb-0"
                    >
                        {{ $t("Checkout") }}
                    </h5>
                </div>
                <nav>
                    <div class="pulsante-indietro"></div>
                </nav>
            </header>
            <main>
                <div
                    v-if="isStepLoading"
                    class="loading-indicator"
                >
                    <div class="loading-square"></div>
                    <div class="loading-square"></div>
                    <div class="loading-square"></div>
                    <div class="loading-square"></div>
                    <div class="loading-square"></div>
                </div>
                <!--<div
                    class="container-fluid mt-4"
                    v-if="!isStepLoading"
                >
                    <div class="row align-items-center">
                        <div class="col-md-6 col-lg-8">
                            <h2 class="titolo-pagina text-uppercase mb-0">{{ $t("Cassa") }}</h2>
                            <p class="numero-prodotti mb-0 mt-1">{{ numCartItems }} prodotti; Subtotale: {{ checkoutSummary.subTotal | toCurrency }}</p>
                        </div>
                        <div class="col-md-6 col-lg-4 mt-4 mt-md-0">
                            <p class="autore-album text-md-right mb-0">{{ checkoutSummary.author }}</p>
                        </div>
                    </div>
                </div>-->

                <div
                    class="visualizzazione-checkout mt-5"
                    v-if="!isStepLoading"
                >
                    <div
                        class="container-fluid"
                        v-if="!isStepOrderConfirmed"
                    >
                        <div class="form-container row">
                            <!--STEP 1-->
                            <transition name="slide">
                                <div
                                    id="step-1"
                                    class="step col-lg-8 offset-lg-2 col-md-10 offset-md-1"
                                    v-if="isStepShippingAddress"
                                >
                                    <div class="font-weight-bold">
                                        {{ $t("Per poter procedere all'ordine: ") }}
                                        <span v-if="checkoutUser.isNew">{{ $t("crea un account su Rikorda.it, marketplace e piattaforma di stampa online.") }}</span>
                                        <span v-else>{{ $t("usa il tuo account su Rikorda.it, marketplace e piattaforma di stampa online.") }}</span>
                                    </div>

                                    <ValidationObserver v-slot="{ handleSubmit }">
                                        <form
                                            ref="checkUserForm"
                                            id="checkUserForm"
                                            @submit.prevent="handleSubmit(gotoDeliveryMode)"
                                        >
                                            <fieldset class="mt-3">
                                                <div class="form-row">
                                                    <div class="col-sm-6 mb-3">
                                                        <label for="nome">{{ $t("Nome") }} <span class="text-danger">*</span></label>
                                                        <validation-provider
                                                            rules="required"
                                                            v-slot="{ errors }"
                                                        >
                                                            <b-form-input
                                                                type="text"
                                                                name="nome"
                                                                id="nome"
                                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                                v-bind:disabled="checkoutBusy || showAuthPopup"
                                                                v-model="checkoutUser.firstName"
                                                            >
                                                            </b-form-input>
                                                            <span class="text-danger">{{errors[0]}}</span>
                                                        </validation-provider>
                                                    </div>
                                                    <div class="col-sm-6 mb-3">
                                                        <label for="cognome">{{ $t("Cognome") }} <span class="text-danger">*</span></label>
                                                        <validation-provider
                                                            rules="required"
                                                            v-slot="{ errors }"
                                                        >
                                                            <b-form-input
                                                                type="text"
                                                                name="cognome"
                                                                id="cognome"
                                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                                v-bind:disabled="checkoutBusy || showAuthPopup"
                                                                v-model="checkoutUser.lastName"
                                                            >
                                                            </b-form-input>
                                                            <span class="text-danger">{{errors[0]}}</span>
                                                        </validation-provider>
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="col-12 col-sm form-group">
                                                        <label for="email">{{ $t("Email") }} <span class="text-danger">*</span></label>
                                                        <validation-provider
                                                            rules="required|validEmail"
                                                            v-slot="{ touched, valid, invalid, pending, errors, validate }"
                                                            vid="email"
                                                            mode="passive"
                                                            :debounce="5"
                                                        >
                                                            <b-form-input
                                                                type="email"
                                                                name="email"
                                                                id="email"
                                                                ref="email"
                                                                :class="{'rounded-pill rilievo-ombra-interna': true, 'is-valid': touched && !pending && valid, 'is-invalid': touched && !pending && invalid, 'validating': pending}"
                                                                v-bind:disabled="checkoutBusy || showAuthPopup || isPrivateEvent"
                                                                v-model="checkoutUser.email"
                                                                @change="validate() && checkUser"
                                                            >
                                                            </b-form-input>
                                                            <span class="text-danger">{{ $t(errors[0]) }}</span>
                                                        </validation-provider>
                                                    </div>
                                                    <!--div
                                                        class="col-12 col-sm form-group"
                                                        v-if="checkoutUser.isNew"
                                                    >
                                                        <label for="ripeti-email">{{ $t("Ripeti email") }} <span class="text-danger">*</span></label>
                                                        <validation-provider
                                                            rules="required|email|confirmed:email"
                                                            v-slot="{ errors }"
                                                        >
                                                            <b-form-input
                                                                type="email"
                                                                name="ripeti-email"
                                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                                v-bind:disabled="checkoutBusy || showAuthPopup"
                                                                v-model="emailConfirm"
                                                            >
                                                            </b-form-input>
                                                            <span class="text-danger">{{errors[0]}}</span>
                                                        </validation-provider>
                                                    </div-->
                                                </div>
                                                <div
                                                    class="form-row"
                                                    v-if="checkoutUser.isNew"
                                                >
                                                    <div class="col-12 col-sm form-group">
                                                        <label for="password">{{ $t("Password") }} <span class="text-danger">*</span></label>
                                                        <validation-provider
                                                            rules="required"
                                                            v-slot="{ errors }"
                                                            vid="pwdField"
                                                        >
                                                            <b-form-input
                                                                type="password"
                                                                name="password"
                                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                                v-bind:disabled="checkoutBusy || !checkoutUser.isNew || showAuthPopup"
                                                                v-model="checkoutUser.password"
                                                                ref="pwdField"
                                                            >
                                                            </b-form-input>
                                                            <span class="text-danger">{{errors[0]}}</span>
                                                        </validation-provider>
                                                    </div>
                                                    <div class="col-12 col-sm form-group">
                                                        <label for="ripeti-password">{{ $t("Ripeti password") }} <span class="text-danger">*</span></label>
                                                        <validation-provider
                                                            rules="required|confirmed:pwdField"
                                                            v-slot="{ errors }"
                                                        >
                                                            <b-form-input
                                                                type="password"
                                                                name="ripeti-password"
                                                                id="ripeti-password"
                                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                                v-bind:disabled="checkoutBusy || !checkoutUser.isNew || showAuthPopup"
                                                                v-model="passwordConfirm"
                                                            >
                                                            </b-form-input>
                                                            <span class="text-danger">{{errors[0]}}</span>
                                                        </validation-provider>
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="col-sm-6 mb-3">
                                                        <label for="paese">{{ $t("Paese") }} <span class="text-danger">*</span></label>
                                                        <validation-provider
                                                            rules="required"
                                                            v-slot="{ errors }"
                                                        >
                                                            <select
                                                                name="paese"
                                                                id="paese"
                                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                                v-bind:disabled="checkoutBusy || showAuthPopup"
                                                                v-model="checkoutUser.state"
                                                                @change="onChangeCountry"
                                                            >
                                                                <option
                                                                    v-for="country in countryList"
                                                                    :key="country.id"
                                                                    :value="country.id"
                                                                >{{country.name}}</option>
                                                            </select>
                                                            <span class="text-danger">{{errors[0]}}</span>
                                                        </validation-provider>
                                                    </div>
                                                    <div class="col-sm-6 mb-3">
                                                        <label for="province">{{$t('Provincia')}} <span class="text-danger">*</span></label>
                                                        <validation-provider
                                                            rules="required"
                                                            v-slot="{ errors }"
                                                        >
                                                            <select
                                                                name="province"
                                                                id="province"
                                                                ref="province"
                                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                                v-model="checkoutUser.province"
                                                                v-bind:disabled="checkoutBusy || showAuthPopup"
                                                                @change="onChangeProvince"
                                                            >
                                                                <option value="">{{$t('Seleziona provincia')}}</option>
                                                                <option
                                                                    v-for="province in provincesList"
                                                                    v-bind:key="province.Sigla"
                                                                    v-bind:value="province.Sigla"
                                                                    v-bind:selected="province.Sigla === checkoutUser.province"
                                                                >
                                                                    {{province.Provincia}}
                                                                </option>
                                                            </select>
                                                            <span class="text-danger">{{errors[0]}}</span>
                                                        </validation-provider>
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="col-sm-6 mb-3">
                                                        <label for="city">{{ $t("Città") }} <span class="text-danger">*</span></label>
                                                        <validation-provider
                                                            rules="required"
                                                            v-slot="{ errors }"
                                                        >
                                                            <select
                                                                name="city"
                                                                id="city"
                                                                ref="city"
                                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                                @change="onChangeCity"
                                                                v-model="checkoutUser.city"
                                                                v-bind:disabled="checkoutBusy || showAuthPopup"
                                                            >
                                                                <option
                                                                    value=""
                                                                    :selected="'sel'"
                                                                >{{$t('Seleziona città')}}</option>
                                                                <option
                                                                    v-for="(key, value) in citiesList"
                                                                    v-bind:key="value"
                                                                    v-bind:value="value"
                                                                    v-bind:selected="value === checkoutUser.city"
                                                                >
                                                                    {{value}}
                                                                </option>
                                                            </select>
                                                            <span class="text-danger">{{errors[0]}}</span>
                                                        </validation-provider>
                                                    </div>
                                                    <div class="col-sm-6 mb-3">
                                                        <label for="zip">{{ $t("CAP") }} <span class="text-danger">*</span></label>
                                                        <validation-provider
                                                            rules="required"
                                                            v-slot="{ errors }"
                                                        >
                                                            <select
                                                                name="zip"
                                                                id="zip"
                                                                ref="zip"
                                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                                v-model="checkoutUser.postalCode"
                                                                v-bind:disabled="checkoutBusy || showAuthPopup"
                                                            >
                                                                <option value="">{{$t('Seleziona cap')}}</option>
                                                                <option
                                                                    v-for="zip in zipList"
                                                                    v-bind:key="zip.cap"
                                                                    v-bind:value="zip.cap"
                                                                    v-bind:selected="zip.cap === checkoutUser.postalCode"
                                                                >
                                                                    {{zip.cap}}
                                                                </option>
                                                            </select>
                                                            <span class="text-danger">{{errors[0]}}</span>
                                                        </validation-provider>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <label for="indirizzo">{{ $t("Indirizzo") }} <span class="text-danger">*</span></label>
                                                    <validation-provider
                                                        rules="required"
                                                        v-slot="{ errors }"
                                                    >
                                                        <b-form-input
                                                            type="text"
                                                            name="indirizzo"
                                                            id="indirizzo"
                                                            class="form-control rounded-pill rilievo-ombra-interna"
                                                            v-bind:disabled="checkoutBusy || showAuthPopup"
                                                            v-model="checkoutUser.address"
                                                        >
                                                        </b-form-input>
                                                        <span class="text-danger">{{errors[0]}}</span>
                                                    </validation-provider>
                                                </div>
                                                <div class="form-group">
                                                    <label for="telefono">{{ $t("Telefono") }}</label>
                                                    <validation-provider
                                                        rules=""
                                                        v-slot="{ errors }"
                                                    >
                                                        <b-form-input
                                                            type="tel"
                                                            name="telefono"
                                                            id="telefono"
                                                            class="form-control rounded-pill rilievo-ombra-interna"
                                                            v-bind:disabled="checkoutBusy || showAuthPopup"
                                                            v-model="checkoutUser.tel"
                                                        >
                                                        </b-form-input>
                                                        <span class="text-danger">{{errors[0]}}</span>
                                                    </validation-provider>
                                                </div>
                                            </fieldset>
                                            <fieldset
                                                class="mt-3"
                                                v-if="checkoutUser.isNew"
                                            >
                                                <label for="flag-privacy">
                                                    {{ $t("Consenso al trattamento dati personali in conformità a quanto previsto dall'") }}
                                                    <a
                                                        href="#"
                                                        @click.prevent="onShowPrivacy()"
                                                    >
                                                        {{ $t("informativa sulla privacy") }}
                                                    </a>
                                                </label>
                                                <div class="border rounded p-2">
                                                    <div class="form-check">
                                                        <validation-provider
                                                            :rules="{ required: { allowFalse: false } }"
                                                            v-slot="{ errors }"
                                                        >
                                                            <b-form-checkbox
                                                                class="form-check-input"
                                                                v-model="flagPrivacy"
                                                                id="flag-privacy"
                                                                @click="setConsent('privacy')"
                                                            >
                                                                {{ $t("Ho letto e autorizzo il trattamento dei miei dati personali in conformità a quanto previsto dall'informativa sulla privacy") }} <span class="text-danger">*</span>
                                                            </b-form-checkbox>
                                                            <span class="text-danger d-block">{{errors[0]}}</span>
                                                        </validation-provider>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset
                                                class="mt-3"
                                                v-if="checkoutUser.isNew"
                                            >
                                                <label for="flag-terms">
                                                    {{ $t("Accettazione delle") }}
                                                    <a
                                                        href="#"
                                                        @click.prevent="onShowTerms()"
                                                    >
                                                        {{ $t('condizioni del servizio ed i termini e le condizioni') }}
                                                    </a>
                                                    {{ $t("di vendita.") }}
                                                </label>
                                                <div class="border rounded p-2">
                                                    <div class="form-check">
                                                        <validation-provider
                                                            :rules="{ required: { allowFalse: false } }"
                                                            v-slot="{ errors }"
                                                        >
                                                            <b-form-checkbox
                                                                class="form-check-input"
                                                                v-model="flagTerms"
                                                                id="flag-terms"
                                                                @click="setConsent('terms')"
                                                            >
                                                                {{ $t("Accetto le condizioni del servizio ed i termini e le condizioni di vendita") }} <span class="text-danger">*</span>
                                                            </b-form-checkbox>
                                                            <span class="text-danger d-block">{{errors[0]}}</span>
                                                        </validation-provider>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset
                                                class="mt-3"
                                                v-if="checkoutUser.isNew"
                                            >
                                                <label for="flag-marketing">
                                                    {{ $t("Consenso al") }}
                                                    <a
                                                        href="#"
                                                        @click.prevent="onShowPrivacy()"
                                                    >
                                                        {{ $t('trattamento dei dati personali') }}
                                                    </a>
                                                    {{ $t("ai fini promozionali del servizio stesso.") }}
                                                </label>
                                                <div class="border rounded p-2">
                                                    <div class="form-check">
                                                        <validation-provider
                                                            :rules="{ required: { allowFalse: true } }"
                                                            v-slot="{ errors }"
                                                        >
                                                            <b-form-checkbox
                                                                class="form-check-input"
                                                                v-model="flagMarketing"
                                                                id="flag-marketing"
                                                                @click="setConsent('marketing')"
                                                            >
                                                                {{ $t("Acconsento al trattamento dei dati personali ai fini promozionali del servizio stesso") }}
                                                                <!--span class="text-danger">*</span-->
                                                            </b-form-checkbox>
                                                            <span class="text-danger d-block">{{errors[0]}}</span>
                                                        </validation-provider>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <div class="text-md-right">
                                                <button
                                                    role="button"
                                                    class="pulsante-step-next btn btn-primary btn-rikorda1 mt-3 mb-0 d-block d-md-inline-block mx-auto mx-md-0"
                                                    type="submit"
                                                >{{ $t('Avanti') }}</button>
                                            </div>
                                        </form>
                                    </ValidationObserver>
                                </div>
                            </transition>
                            <!--/STEP 1-->

                            <!--STEP 2-->
                            <transition name="slide">
                                <div
                                    id="step-2"
                                    class="step col-lg-8 offset-lg-2 col-md-10 offset-md-1"
                                    v-if="isStepDeliveryMode"
                                >
                                    <!--<a
                                            role="button"
                                            class="pulsante-step-prev btn btn-primary btn-rikorda1 mb-3 mt-0"
                                            @click="gotoStepShippingAddress()"
                                        >{{ $t('Indietro') }}</a>-->
                                    <fieldset>
                                        <!--<h5 class="text-uppercase">{{ $t('Modalità di consegna') }}</h5>-->
                                        <p
                                            v-if="hasDeliveryType('shop') && hasDeliveryType('home')"
                                            class="mb-0 text-uppercase font-titoli-rikorda text-blurikorda"
                                        >
                                            {{ $t('Scegli se ricevere presso il punto vendita o a domicilio') }}
                                        </p>
                                        <div class="scelta-opzioni d-sm-flex justify-content-between mt-3">
                                            <div
                                                class="card w-100 mx-sm-1 mx-lg-3"
                                                v-if="hasDeliveryType('shop')"
                                                v-bind:class="{ active: (deliveryTypeKey == 'shop') }"
                                            >
                                                <div
                                                    class="card-header position-relative text-white d-flex justify-content-start align-items-center pr-5 px-md-3"
                                                    @click="setDeliveryType('shop')"
                                                >
                                                    <font-awesome-icon
                                                        :icon="['fas', 'store']"
                                                        size="2x"
                                                    />
                                                    <i18n
                                                        path="PressoPuntoVendita"
                                                        tag="span"
                                                        class="tipo-consegna ml-2"
                                                    >
                                                        <strong>{{ $t('Presso il punto vendita') }}</strong>
                                                    </i18n>
                                                    <span class="finto-radiobutton d-inline-flex justify-content-center align-items-center d-md-none rounded"></span>
                                                </div>
                                                <div class="card-body d-none d-md-block">
                                                    <table class="mb-0 w-100">
                                                        <tbody>
                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                <td class="col-7 pr-1 text-right">
                                                                    {{ $t('Totale articoli') }}:
                                                                </td>
                                                                <td class="col-5 pl-1 text-right">
                                                                    {{ getSubTotal('cash') | toCurrency }}
                                                                </td>
                                                            </tr>
                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                <td class="col-7 pr-1 text-right">
                                                                    {{ $t('Spese di consegna in negozio') }}:
                                                                </td>
                                                                <td class="col-5 pl-1 text-right">
                                                                    {{ getMinDeliveryPrice('shop') | toCurrency }}
                                                                </td>
                                                            </tr>
                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                <td class="col-7 pr-1 text-right">{{$t('Totale')}}:</td>
                                                                <td class="col-5 pl-1 text-right">
                                                                    {{ getSubTotal('cash') + getMinDeliveryPrice('shop')
                                                                    | toCurrency}}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <hr />
                                                    <h6 class="mb-0 text-uppercase">{{ $t('Ritiro presso il venditore:') }}</h6>
                                                    <address class="mb-0 mt-1">
                                                        <strong class="text-blurikorda">{{ deliveryTypes.shop.address.name }}</strong>
                                                        <br />
                                                        {{ deliveryTypes.shop.address.address }}
                                                        <br />
                                                        {{ deliveryTypes.shop.address.zip }} {{ deliveryTypes.shop.address.city }} ({{ deliveryTypes.shop.address.province }})
                                                    </address>
                                                    <i18n
                                                        path="DataConsegnaPrevista"
                                                        tag="p"
                                                        class="mb-0 mt-3 text-blurikorda font-titoli-rikorda"
                                                    >
                                                        <strong>{{ deliveryTypes.shop.deliveryDate | formatDateSlash }}</strong>
                                                    </i18n>
                                                </div>
                                                <div class="card-footer text-muted d-none d-md-flex justify-content-end flex-wrap align-items-right">
                                                    <a
                                                        role="button"
                                                        class="btn btn-primary btn-rikorda1 my-1"
                                                        @click="gotoPaymentMode('shop')"
                                                    >{{ $t('Seleziona') }}</a>
                                                </div>
                                            </div>
                                            <div
                                                class="card w-100 mx-sm-1 mx-lg-3"
                                                v-if="hasDeliveryType('home')"
                                                v-bind:class="{active: (deliveryTypeKey == 'home')}"
                                            >
                                                <div
                                                    class="card-header position-relative text-white d-flex justify-content-start align-items-center pr-5 px-md-3"
                                                    @click="setDeliveryType('home')"
                                                >
                                                    <font-awesome-icon
                                                        :icon="['fas', 'truck']"
                                                        size="2x"
                                                    />
                                                    <i18n
                                                        path="PressoDomicilio"
                                                        tag="span"
                                                        class="tipo-consegna ml-2"
                                                    >
                                                        <strong>{{ $t('A domicilio') }}</strong>
                                                    </i18n>
                                                    <span class="finto-radiobutton d-inline-flex justify-content-center align-items-center d-md-none rounded"></span>
                                                </div>
                                                <div class="card-body d-none d-md-block">
                                                    <table class="mb-0 w-100">
                                                        <tbody>
                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                <td class="col-7 pr-1 text-right">
                                                                    {{ $t('Totale articoli') }}:
                                                                </td>
                                                                <td class="col-5 pl-1 text-right">
                                                                    {{ getSubTotal('paypal') | toCurrency }}
                                                                </td>
                                                            </tr>
                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                <td class="col-7 pr-1 text-right">
                                                                    {{ $t('Spese di consegna') }}:
                                                                </td>
                                                                <td class="col-5 pl-1 text-right">
                                                                    {{ getMinDeliveryPrice('home') | toCurrency }}
                                                                </td>
                                                            </tr>
                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                <td class="col-7 pr-1 text-right">{{$t('Totale')}}:</td>
                                                                <td class="col-5 pl-1 text-right">
                                                                    {{ getSubTotal('paypal') +
                                                                    getMinDeliveryPrice('home') | toCurrency}}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <hr />
                                                    <h6 class="mb-0 text-uppercase">{{ $t('Indirizzo di spedizione') }}</h6>
                                                    <address class="mb-0 mt-1">
                                                        <strong class="text-blurikorda">{{ checkoutUser.firstName }} {{ checkoutUser.lastName }}</strong>
                                                        <br />
                                                        {{ checkoutUser.address }}
                                                        <br v-if="checkoutUser.address2" />
                                                        {{ checkoutUser.address2 }}
                                                        <br />
                                                        {{ checkoutUser.postalCode }} {{ checkoutUser.city }} ({{ checkoutUser.province }})
                                                    </address>
                                                    <b-form-checkbox
                                                        class="mt-3"
                                                        v-if="isStepDeliveryMode && !isInvoiceRequired"
                                                        v-model="flagFattura"
                                                        @change="onRequireInvoice"
                                                    >
                                                        {{ $t('Desidero ricevere fattura') }}
                                                    </b-form-checkbox>
                                                    <i18n
                                                        path="DataConsegnaPrevista"
                                                        tag="p"
                                                        class="mb-0 mt-3 text-blurikorda font-titoli-rikorda"
                                                    >
                                                        <strong>{{ deliveryTypes.home.deliveryDate | formatDateSlash }}</strong>
                                                    </i18n>
                                                    <div class="row mt-3">
                                                        <div class="col-12 col-xl-5">
                                                            <p class="mb-0">{{ $t('Spedizione: Corriere') }}</p>
                                                        </div>
                                                        <!--<div class="col-12 mt-3 col-xl-7 mt-xl-0 border rounded p-2">
                                                                <div class="form-check">
                                                                    <input
                                                                        class="form-check-input"
                                                                        type="checkbox"
                                                                        value
                                                                        id="richiesta-fattura"
                                                                    />
                                                                    <label
                                                                        class="form-check-label"
                                                                        for="richiesta-fattura"
                                                                    >{{ $t('Desidero ricevere la fattura.') }}</label>
                                                                </div>
                                                            </div>-->
                                                    </div>
                                                </div>
                                                <div class="card-footer text-muted d-none d-md-flex justify-content-between flex-wrap align-items-center">
                                                    <a
                                                        role="button"
                                                        class="btn btn-light btn-rikorda2 border my-1"
                                                        @click="gotoStepShippingAddress()"
                                                    >{{ $t('Cambia indirizzo') }}</a>
                                                    <a
                                                        role="button"
                                                        class="btn btn-primary btn-rikorda1 my-1"
                                                        @click="gotoPaymentMode('home')"
                                                    >{{ $t('Seleziona') }}</a>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="dati-consegna-mobile d-md-none">
                                            <!--in questo div viene messo il contenuto di card-body e di card-footer della card cliccata (cioè quella con la classe active)-->
                                            <div class="card-body d-block">
                                                <!--qui viene messo il contenuto di card-body della card cliccata-->
                                                <i18n
                                                    path="DataConsegnaPrevista"
                                                    tag="p"
                                                    class="mb-0 text-blurikorda font-titoli-rikorda"
                                                >
                                                    <strong>{{ deliveryTypes[deliveryTypeKey].deliveryDate | formatDateSlash }}</strong>
                                                </i18n>
                                                <table class="mb-0 mt-3 w-100">
                                                    <tbody>
                                                        <hr class="m-0">
                                                        <tr class="row align-items-center text-blurikorda py-1">
                                                            <td class="col-7 pr-1 text-left">
                                                                {{ $t('Totale articoli') }}:
                                                            </td>
                                                            <td class="col-5 pl-1 text-right">
                                                                {{ getSubTotal('cash') | toCurrency }}
                                                            </td>
                                                        </tr>
                                                        <hr class="m-0">
                                                        <tr class="row align-items-center text-blurikorda py-1">
                                                            <td class="col-7 pr-1 text-left">
                                                                {{ $t('Spese di consegna')}}:
                                                            </td>
                                                            <td class="col-5 pl-1 text-right">
                                                                {{ getMinDeliveryPrice(deliveryTypeKey) | toCurrency }}
                                                            </td>
                                                        </tr>
                                                        <hr class="m-0">
                                                        <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                            <td class="col-7 pr-1 text-left">{{$t('Totale')}}:</td>
                                                            <td class="col-5 pl-1 text-right">
                                                                {{ getSubTotal('cash') +
                                                                getMinDeliveryPrice(deliveryTypeKey) | toCurrency}}
                                                            </td>
                                                        </tr>
                                                        <hr class="m-0">
                                                    </tbody>
                                                </table>
                                                <h6 class="mb-0 mt-3 text-uppercase">{{ deliveryTypeKey === 'shop' ? $t('Ritiro presso il venditore:') : $t('Indirizzo di spedizione') }}</h6>
                                                <address
                                                    v-if="deliveryTypeKey === 'shop'"
                                                    class="mb-0 mt-1"
                                                >
                                                    <strong class="text-blurikorda">{{ deliveryTypes[deliveryTypeKey].address.name }}</strong>
                                                    <br />
                                                    {{ deliveryTypes[deliveryTypeKey].address.address }}
                                                    <br />
                                                    {{ deliveryTypes[deliveryTypeKey].address.zip }} {{ deliveryTypes[deliveryTypeKey].address.country }} ({{ deliveryTypes[deliveryTypeKey].address.province }})
                                                </address>
                                                <address
                                                    v-if="deliveryTypeKey === 'home'"
                                                    class="mb-0 mt-1"
                                                >
                                                    <strong class="text-blurikorda">
                                                        {{checkoutUser.firstName }} {{checkoutUser.lastName}}</strong>
                                                    <br />
                                                    {{ checkoutUser.address }}
                                                    <br />
                                                    {{checkoutUser.postalCode }} {{checkoutUser.city }}
                                                    ({{checkoutUser.province }})
                                                </address>
                                                <b-form-checkbox
                                                    class="mt-3"
                                                    v-if="isStepDeliveryMode && !isInvoiceRequired && deliveryTypeKey === 'home'"
                                                    v-model="flagFattura"
                                                    @change="onRequireInvoice"
                                                >
                                                    {{ $t('Desidero ricevere fattura') }}
                                                </b-form-checkbox>
                                                <!--fine card-body per mobile-->
                                            </div>
                                            <div class="card-footer bg-transparent border-0 text-muted d-flex justify-content-between flex-wrap align-items-center">
                                                <!--qui viene messo il contenuto di card-footer della card cliccata-->
                                                <a
                                                    role="button"
                                                    class="btn btn-primary btn-rikorda1 my-1"
                                                    @click="gotoPaymentMode(deliveryTypeKey)"
                                                >{{ $t('Seleziona') }}</a>
                                                <!--fine card-footer per mobile-->
                                            </div>
                                            <!--fine div con card-body e card-footer-->
                                        </div>
                                    </fieldset>
                                </div>
                            </transition>
                            <!--/STEP 2-->

                            <!--STEP 3-->
                            <transition name="slide">
                                <div
                                    id="step-3"
                                    class="step col-lg-8 offset-lg-2 col-md-10 offset-md-1"
                                    v-if="isStepPaymentMode"
                                >
                                    <!--<a
                                            role="button"
                                            class="pulsante-step-prev btn btn-primary btn-rikorda1 mb-3 mt-0"
                                            @click="gotoStepDeliveryMode()"
                                        >{{ $t('Indietro') }}</a>-->
                                    <fieldset>
                                        <!--<h5 class="text-uppercase">{{$t('Modalità di pagamento')}}</h5>-->
                                        <p class="mb-0 text-uppercase font-titoli-rikorda text-blurikorda">{{$t('Scegli la modalità di pagamento')}}</p>
                                        <div class="scelta-opzioni d-sm-flex justify-content-between mt-3">
                                            <div
                                                v-if="hasPaymentType('cash')"
                                                class="card w-100 mx-sm-1 mx-lg-3"
                                                v-bind:class="{ active: (paymentTypeKey == 'cash') }"
                                            >
                                                <div
                                                    class="card-header position-relative text-white d-flex justify-content-start align-items-center pr-5 px-md-3"
                                                    @click="setPaymentType('cash')"
                                                >
                                                    <font-awesome-icon
                                                        :icon="['fas', 'euro-sign']"
                                                        size="2x"
                                                    />
                                                    <span class="tipo-pagamento ml-2">{{$t('Pagamento al ritiro')}}</span>
                                                    <span class="finto-radiobutton d-inline-flex justify-content-center align-items-center d-md-none rounded"></span>
                                                </div>
                                                <div class="card-body d-none d-md-block">
                                                    <h6 class="mb-0 font-light-rikorda">{{$t("Pagherai solo al momento del ritiro dell'ordine presso il punto vendita selezionato")}}</h6>

                                                    <table class="mb-0 mt-3 w-100">
                                                        <tbody>
                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                <td class="col-7 pr-1 text-right">
                                                                    {{$t('Totale Articoli')}}:
                                                                </td>
                                                                <td class="col-5 pl-1 text-right">
                                                                    {{ getSubTotal('cash') | toCurrency}}
                                                                </td>
                                                            </tr>
                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                <td class="col-7 pr-1 text-right">
                                                                    {{$t('Spese di consegna')}}:
                                                                </td>
                                                                <td class="col-5 pl-1 text-right">
                                                                    {{ getShippingCost('cash') | toCurrency}}
                                                                </td>
                                                            </tr>
                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                <td class="col-7 pr-1 text-right">{{$t('Totale')}}:</td>
                                                                <td class="col-5 pl-1 text-right">
                                                                    {{ getTotal('cash') | toCurrency}}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="card-footer text-muted d-none d-md-flex justify-content-center flex-wrap align-items-right">
                                                    <button
                                                        class="btn btn-primary btn-rikorda1 mx-auto my-1"
                                                        @click.prevent="onCashSubmit()"
                                                        :disabled="checkoutBusy || showAuthPopup"
                                                    >{{cashCheckout ? 'Invio in corso...' : $t('Invia ordine e paga in negozio')}}</button>
                                                </div>
                                            </div>
                                            <div
                                                v-if="hasPaymentType('paypal')"
                                                class="card w-100 mx-sm-1 mx-lg-3"
                                                v-bind:class="{ active: (paymentTypeKey == 'paypal'), 'd-none': (deliveryTypeKey == 'home'), 'd-md-flex': (deliveryTypeKey == 'home') }"
                                            >
                                                <!--nascondere l'elemento se è stata scelta la spedizione-->
                                                <div
                                                    class="card-header position-relative text-white d-flex justify-content-start align-items-center pr-5 px-md-3"
                                                    @click="setPaymentType('paypal')"
                                                >
                                                    <font-awesome-icon
                                                        :icon="['fab', 'paypal']"
                                                        size="2x"
                                                    />
                                                    <span class="tipo-pagamento ml-2">{{$t('Pagamento anticipato online')}}</span>
                                                    <span class="finto-radiobutton d-inline-flex justify-content-center align-items-center d-md-none rounded"></span>
                                                </div>
                                                <div class="card-body d-none d-md-block">
                                                    <div
                                                        v-show="deliveryTypeKey != 'shop'"
                                                        class="paypal-logo text-center"
                                                    >
                                                        <img
                                                            src="/images/logo-paypal.png"
                                                            alt="PayPal"
                                                            title="PayPal"
                                                            class="mw-100"
                                                        />
                                                    </div>

                                                    <h6
                                                        v-show="deliveryTypeKey == 'shop'"
                                                        class="mb-0 font-light-rikorda"
                                                    >
                                                        {{$t('Paghi subito e ritiri presso il punto vendita')}}<br />&nbsp;</h6>

                                                    <table
                                                        v-show="deliveryTypeKey == 'shop'"
                                                        class="mt-3 mb-0 w-100"
                                                    >
                                                        <tbody>
                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                <td class="col-7 pr-1 text-right">
                                                                    {{$t('Totale Articoli')}}:
                                                                </td>
                                                                <td class="col-5 pl-1 text-right">
                                                                    {{getSubTotal('paypal') | toCurrency }}
                                                                </td>
                                                            </tr>
                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                <td class="col-7 pr-1 text-right">
                                                                    {{$t('Spese di consegna')}}:
                                                                </td>
                                                                <td class="col-5 pl-1 text-right">
                                                                    {{getShippingCost('paypal') | toCurrency }}
                                                                </td>
                                                            </tr>
                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                <td class="col-7 pr-1 text-right">{{$t('Totale')}}:</td>
                                                                <td class="col-5 pl-1 text-right">
                                                                    {{ getTotal('paypal') | toCurrency }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <b-form-checkbox
                                                        class="mt-3"
                                                        v-if="isStepPaymentMode && !isInvoiceRequired && deliveryTypeKey === 'shop'"
                                                        v-model="flagFattura"
                                                        @change="onRequireInvoice"
                                                    >
                                                        {{ $t('Desidero ricevere fattura') }}
                                                    </b-form-checkbox>
                                                </div>
                                                <div class="card-footer text-muted d-none d-md-flex justify-content-center flex-wrap align-items-center">
                                                    <!-- START PAYPAL -->
                                                    <form
                                                        ref="paypalForm"
                                                        :action="getPaypalUrl()"
                                                        method="post"
                                                        target="_top"
                                                        @submit.prevent="onPaypalSubmit()"
                                                    >
                                                        <input
                                                            type="hidden"
                                                            name="cmd"
                                                            value="_xclick"
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="business"
                                                            value=""
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="lc"
                                                            value="IT"
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="item_name"
                                                            value="form key"
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="amount"
                                                            id="paypal_amount"
                                                            value=""
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="currency_code"
                                                            value="EUR"
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="button_subtype"
                                                            value="services"
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="no_note"
                                                            value="0"
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="bn"
                                                            value="PP-BuyNowBF:btn_buynowCC_LG.gif:NonHostedGuest"
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="return"
                                                            v-model="paypalReturn"
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="cancel_return"
                                                            value=""
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="notify_url"
                                                            value=""
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="item_number"
                                                            value=""
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="custom"
                                                            value="this is the custom variable. it is named 'cm' in the returned Url."
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="rm"
                                                            value="1"
                                                        >
                                                        <input
                                                            type="hidden"
                                                            name="cbt"
                                                            value="Return to Merchant"
                                                        >
                                                        <button
                                                            type="submit"
                                                            name="btnSubmit"
                                                            class="btn btn-primary btn-rikorda1 mx-auto my-1"
                                                            :disabled="checkoutBusy || showAuthPopup"
                                                        >{{paypalCheckout ? 'Invio in corso...' : $t('Invia ordine e paga con PayPal')}}</button>
                                                        <!--input
                                                                type="image"
                                                                src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/buy-logo-large.png"
                                                                border="0"
                                                                name="submit"
                                                                alt="PayPal è il metodo rapido e sicuro per pagare e farsi pagare online."
                                                            -->
                                                        <!--input
                                                                alt="PayPal - The safer, easier way to pay online!"
                                                                name="submit"
                                                                src="https://www.paypalobjects.com/it_IT/i/btn/btn_buynowCC_LG.gif"
                                                                type="image"
                                                            -->
                                                        <img
                                                            src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                                                            alt=""
                                                            width="1"
                                                            height="1"
                                                            border="0"
                                                        >
                                                    </form><!-- END PAYPAL -->
                                                </div>
                                            </div>
                                        </div>

                                        <div class="dati-pagamento-mobile d-md-none">
                                            <!--in questo div viene messo il contenuto di card-body e di card-footer della card cliccata (cioè quella con la classe active)-->
                                            <div class="card-body d-block">
                                                <!--qui viene messo il contenuto di card-body della card cliccata-->
                                                <p
                                                    v-show="deliveryTypeKey == 'shop' && paymentTypeKey == 'cash'"
                                                    class="mb-0"
                                                >
                                                    {{ $t('Pagherai solo al momento del ritiro dell\'ordine presso il punto vendita selezionato') }}
                                                </p>
                                                <p
                                                    v-show="deliveryTypeKey == 'shop' && paymentTypeKey != 'cash'"
                                                    class="mb-0"
                                                >
                                                    {{ $t('Paghi subito e ritiri presso il punto vendita') }}
                                                </p>
                                                <table
                                                    v-show="deliveryTypeKey == 'shop'"
                                                    class="mb-0 mt-3 w-100"
                                                >
                                                    <tbody>
                                                        <hr class="m-0">
                                                        <tr class="row align-items-center text-blurikorda py-1">
                                                            <td class="col-7 pr-1 text-left">
                                                                {{ $t('Totale articoli')}}:
                                                            </td>
                                                            <td class="col-5 pl-1 text-right">
                                                                {{ getSubTotal('paypal') | toCurrency }}
                                                            </td>
                                                        </tr>
                                                        <hr class="m-0">
                                                        <tr class="row align-items-center text-blurikorda py-1">
                                                            <td class="col-7 pr-1 text-left">
                                                                <span v-show="deliveryTypeKey == 'shop'">{{ $t('Spese di consegna in negozio')}}:</span>
                                                                <span v-show="deliveryTypeKey != 'shop'">{{ $t('Spese di consegna')}}:</span>
                                                            </td>
                                                            <td class="col-5 pl-1 text-right">
                                                                {{ getShippingCost(paymentTypeKey) | toCurrency }}
                                                            </td>
                                                        </tr>
                                                        <hr class="m-0">
                                                        <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                            <td class="col-7 pr-1 text-left">{{$t('Totale')}}:</td>
                                                            <td class="col-5 pl-1 text-right">
                                                                {{ getSubTotal('paypal') +
                                                                getShippingCost(paymentTypeKey) | toCurrency }}
                                                            </td>
                                                        </tr>
                                                        <hr class="m-0">
                                                    </tbody>
                                                </table>
                                                <b-form-checkbox
                                                    class="mt-3"
                                                    v-if="isStepPaymentMode && !isInvoiceRequired && (deliveryTypeKey === 'shop' && paymentTypeKey === 'paypal')"
                                                    v-model="flagFattura"
                                                    @change="onRequireInvoice"
                                                >
                                                    {{ $t('Desidero ricevere fattura') }}
                                                </b-form-checkbox>
                                                <div
                                                    v-show="deliveryTypeKey != 'shop'"
                                                    class="paypal-logo"
                                                >
                                                    <img
                                                        src="/images/logo-paypal.png"
                                                        alt="PayPal"
                                                        title="PayPal"
                                                        class="mw-100"
                                                    />
                                                </div>
                                                <!--fine card-body per mobile-->
                                            </div>
                                            <div class="card-footer bg-transparent border-0 text-muted d-flex justify-content-between flex-wrap align-items-center">
                                                <!--qui viene messo il contenuto di card-footer della card cliccata-->
                                                <button
                                                    class="btn btn-primary btn-rikorda1 mx-auto my-1"
                                                    @click.prevent="onMobileSubmit()"
                                                    :disabled="checkoutBusy || showAuthPopup"
                                                >{{ (cashCheckout||paypalCheckout) ? 'Invio in corso...' : paymentTypeKey === 'cash' ? $t('Invia ordine e ritira in negozio') : $t('Invia ordine e paga con PayPal') }}</button>
                                                <!--fine card-footer per mobile-->
                                            </div>
                                            <div class="card-body d-block">
                                                <!--qui viene messo il contenuto di card-body della card cliccata-->
                                                <h6 class="mb-0 text-uppercase">{{ deliveryTypeKey === 'shop' ? $t('Ritiro presso il venditore:') : $t('Indirizzo di spedizione') }}</h6>
                                                <address
                                                    v-if="deliveryTypeKey === 'shop'"
                                                    class="mb-0 mt-1"
                                                >
                                                    <strong class="text-blurikorda">{{ deliveryTypes[deliveryTypeKey].address.name }}</strong>
                                                    <br />
                                                    {{ deliveryTypes[deliveryTypeKey].address.address }}
                                                    <br />
                                                    {{ deliveryTypes[deliveryTypeKey].address.zip }} {{ deliveryTypes[deliveryTypeKey].address.country }} ({{ deliveryTypes[deliveryTypeKey].address.province }})
                                                </address>
                                                <address
                                                    v-if="deliveryTypeKey === 'home'"
                                                    class="mb-0 mt-1"
                                                >
                                                    <strong class="text-blurikorda">
                                                        {{checkoutUser.firstName }} {{checkoutUser.lastName}}</strong>
                                                    <br />
                                                    {{ checkoutUser.address }}
                                                    <br />
                                                    {{checkoutUser.postalCode }} {{checkoutUser.city }}
                                                    ({{checkoutUser.province }})
                                                </address>
                                                <i18n
                                                    path="DataConsegnaPrevista"
                                                    tag="p"
                                                    class="mb-0 mt-3 text-blurikorda font-titoli-rikorda"
                                                >
                                                    <strong>{{ deliveryTypes[deliveryTypeKey].deliveryDate | formatDateSlash }}</strong>
                                                </i18n>
                                                <!--fine card-body per mobile-->
                                            </div>
                                            <!--fine div con card-body e card-footer-->
                                        </div>

                                        <div class="text-center">
                                            <span class="text-danger">{{ checkoutError }}</span>
                                        </div>

                                        <div class="dati-spedizione-ritiro mt-3 d-none d-md-block">
                                            <div class="scelta-opzioni">
                                                <div class="card w-100 mx-sm-1 mx-lg-3">
                                                    <div class="card-header text-white px-md-3">
                                                        <span v-show="deliveryTypeKey == 'shop'">Ritiri presso:</span>
                                                        <span v-show="deliveryTypeKey != 'shop'">Spedizione:</span>
                                                    </div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-12 col-md-6">
                                                                <div>
                                                                    <h6
                                                                        v-if="deliveryTypeKey !== 'shop'"
                                                                        class="mb-0 text-uppercase"
                                                                    >{{ $t('Indirizzo di spedizione') }}</h6>
                                                                    <address
                                                                        v-if="deliveryTypeKey === 'shop'"
                                                                        class="mb-0 mt-1"
                                                                    >
                                                                        <strong class="text-blurikorda">{{ deliveryTypes[deliveryTypeKey].address.name }}</strong>
                                                                        <br />
                                                                        {{ deliveryTypes[deliveryTypeKey].address.address }}
                                                                        <br />
                                                                        {{ deliveryTypes[deliveryTypeKey].address.zip }} {{ deliveryTypes[deliveryTypeKey].address.country }} ({{ deliveryTypes[deliveryTypeKey].address.province }})
                                                                    </address>
                                                                    <address
                                                                        v-if="deliveryTypeKey === 'home'"
                                                                        class="mb-0 mt-1"
                                                                    >
                                                                        <strong class="text-blurikorda">
                                                                            {{checkoutUser.firstName }}
                                                                            {{checkoutUser.lastName }}</strong>
                                                                        <br />
                                                                        {{ checkoutUser.address }}
                                                                        <br />
                                                                        {{checkoutUser.postalCode }}
                                                                        {{checkoutUser.city }}
                                                                        ({{checkoutUser.province }})
                                                                    </address>
                                                                </div>
                                                            </div>
                                                            <div class="col-12 col-md-6">
                                                                <div v-if="deliveryTypeKey === 'shop'">
                                                                    <div>
                                                                        <i18n
                                                                            path="DataConsegnaPrevista"
                                                                            tag="p"
                                                                            class="mb-0 text-blurikorda font-titoli-rikorda"
                                                                        >
                                                                            <strong>{{ deliveryTypes.shop.deliveryDate | formatDateSlash }}</strong>
                                                                        </i18n>
                                                                    </div>
                                                                    <p class="mt-3 mb-0">Potrai verificare lo stato di avanzamento nella sezione I MIEI ORDINI.<br>Riceverai una email il giorno prima della spedizione.</p>
                                                                </div>
                                                                <div v-if="deliveryTypeKey !== 'shop'">
                                                                    <table class="mb-0 w-100">
                                                                        <tbody>
                                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                                <td class="col-7 pr-1 text-right">
                                                                                    {{$t('Totale Articoli')}}:
                                                                                </td>
                                                                                <td class="col-5 pl-1 text-right">
                                                                                    {{ getSubTotal('paypal') | toCurrency }}
                                                                                </td>
                                                                            </tr>
                                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                                <td class="col-7 pr-1 text-right">
                                                                                    {{$t('Spese di consegna')}}:
                                                                                </td>
                                                                                <td class="col-5 pl-1 text-right">
                                                                                    {{ getShippingCost(paymentTypeKey) | toCurrency }}
                                                                                </td>
                                                                            </tr>
                                                                            <tr class="row align-items-center text-blurikorda font-titoli-rikorda py-1">
                                                                                <td class="col-7 pr-1 text-right">{{$t('Totale')}}:</td>
                                                                                <td class="col-5 pl-1 text-right">
                                                                                    {{ getSubTotal('paypal') +
                                                                                  getShippingCost(paymentTypeKey) | toCurrency }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            </transition>
                            <!--STEP 3-->

                            <div
                                class="mt-3 dati-fatturazione step col-lg-8 offset-lg-2 col-md-10 offset-md-1"
                                v-if="(isStepDeliveryMode || (isStepPaymentMode && deliveryTypeKey == 'shop')) &&
                                 (flagFattura || (isInvoiceRequired))"
                            >
                                <div class="scelta-opzioni">
                                    <div class="card w-100 mx-sm-1 mx-lg-3 active">
                                        <div class="card-header text-white px-md-3">
                                            <span>
                                                {{ $t('Dati fatturazione') }}
                                            </span>
                                        </div>
                                        <div class="card-body">
                                            <validation-observer
                                                tag="form"
                                                id="user-invoice-form"
                                                ref="user-invoice-form"
                                            >
                                                <user-invoice-form
                                                    :invoice-data="userInvoiceData"
                                                    :invoice-provinces="provincesList"
                                                    :invoice-cities="invoiceCitiesList"
                                                    :invoice-zips="invoiceZipList"
                                                />
                                            </validation-observer>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--       PARTE NON FATTA DA DARIO        -->
                    <div
                        class="container-fluid"
                        v-if="isStepOrderConfirmed"
                    >
                        <div class="row align-items-center">
                            <div class="col-md-6 col-lg-8">
                                <h2 class="titolo-pagina text-uppercase mb-0">{{ $t("Conferma Ordine") }}</h2>
                            </div>
                        </div>
                    </div>
                    <div
                        class="visualizzazione-checkout mt-5"
                        v-if="isStepOrderConfirmed"
                    >
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-6 col-lg-8 deliveryInfo">
                                    <h5 class="titolo-pagina text-uppercase mb-0">{{ $t("ModalitaConsegna", {deliveryLabel: deliveryLabel}) }}</h5>
                                    <div class="shippingAddress">
                                        <span>{{createdOrder.shippingData.name}}</span>
                                        <br />
                                        <span>{{createdOrder.shippingData.address}}</span>
                                        <br />
                                        <span>{{createdOrder.shippingData.zip}} {{createdOrder.shippingData.city}} {{createdOrder.shippingData.province}}</span>
                                        <br />
                                        <span>{{createdOrder.shippingData.country}}</span>
                                    </div>
                                </div>
                                <div class="form-container col-sm-12">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">{{ $t('N° Ordine') }}</th>
                                                <th scope="col">{{ $t('Prodotto') }}</th>
                                                <th scope="col">{{ $t('Quantità') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(orderItem, orderIndex) in createdOrder.orderCheckoutInfoDetails"
                                                v-bind:key="orderIndex"
                                            >
                                                <th scope="row">{{ orderItem.trackingId }}</th>
                                                <td>{{ orderItem.articleDescription }}</td>
                                                <td>{{ orderItem.quantity }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <gallery-popup-login
                    v-if="showAuthPopup"
                    :username="loginUsername"
                    @login="onUserLogin"
                    @close="onUserLoginClose"
                />

            </main>
            <gallery-footer
                ref="footer"
                :showRikorda="true"
            />
        </div>
    </div>
</template>

<script>
import GalleryHeader from "../../components/gallery/Header";
import GalleryFooter from "../../components/gallery/Footer";
//import SlideTransition from "../../components/gallery/SlideTransition";
import GalleryPopupLogin from "../../components/gallery/PopupLogin";
import UserInvoiceForm from "../../components/account/UserInvoiceForm";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, email, confirmed } from "vee-validate/dist/rules";

const CHECKOUT_STEP_LOADING_CHECKOUT_DATA = "loadingCheckoutData";
const CHECKOUT_STEP_SHIPPING_ADDRESS = "shippingAddress";
const CHECKOUT_STEP_DELIVERY_MODE = "deliveryMode";
const CHECKOUT_STEP_PAYMENT_MODE = "paymentMode";
const CHECKOUT_STEP_ASK_CONFIRM = "askConfirm";
const CHECKOUT_STEP_ORDER_CONFIRMED = "orderConfirmed";

export default {
    name: "GalleryCheckout",

    components: {
        GalleryHeader,
        GalleryFooter,
        ValidationProvider,
        ValidationObserver,
        GalleryPopupLogin,
        UserInvoiceForm
    },

    data() {
        return {
            authBusy: false,
            checkoutBusy: false,
            checkoutSummary: {},
            checkoutStep: CHECKOUT_STEP_LOADING_CHECKOUT_DATA,
            checkoutUser: {},
            checkoutError: null,
            emailConfirm: "",
            passwordConfirm: "",
            createdOrder: {},
            deliveryTypes: {},
            lastCheckoutMail: "",
            loginPassword: "",
            loginUsername: "",
            pageTitle: "Checkout",
            deliveryTypeKey: "",
            paymentTypeKey: "",
            paypalReturn: null,
            recoveryPasswordSent: false,
            shippingModeSet: false,
            showAuthPopup: false,
            showPasswordForgot: false,
            validateLoginPwdError: false,
            countryList: [
                { id: null, name: "Seleziona nazione" },
                { id: "Italia", name: "Italia" }
            ],
            provincesList: [],
            citiesList: {},
            zipList: [],
            flagPrivacy: false,
            flagTerms: false,
            flagMarketing: false,
            cashCheckout: false,
            paypalCheckout: false,
            flagFattura: false,
            userInvoiceData: {},
            invoiceCitiesList: {},
            invoiceZipList: []
        };
    },

    mounted() {
        this.flagFattura = this.isInvoiceRequired;

        this.$api
            .getUserInvoiceData()
            .then((result) => {
                if (result.userInvoiceData) {
                    let userInvoiceData = result.userInvoiceData;
                    let piva = userInvoiceData["piva"].trim();
                    if (!piva) {
                        userInvoiceData.invoiceType = "person";
                    } else {
                        if (piva != userInvoiceData["codiceFiscale"].trim()) {
                            userInvoiceData.invoiceType = "individual";
                        } else {
                            userInvoiceData.invoiceType = "company";
                        }
                    }
                    this.$api
                        .getItalyCities(userInvoiceData.provincia)
                        .then((result) => {
                            this.invoiceCitiesList = result.cities;
                            this.invoiceZipList =
                                result.cities[userInvoiceData.citta];
                            this.userInvoiceData = userInvoiceData;
                        })
                        .catch((error) => {
                            console.error("GET_ITALY_CITIES", error);
                        });
                }
            })
            .catch((error) => {
                console.error("GET_USER_INVOICE_DATA", error);
            });

        this.$store
            .dispatch("GET_CHECKOUT_SUMMARY")
            .then((result) => {
                console.debug("GET_CHECKOUT_SUMMARY", result);

                if (result.userState.numCartItems === 0) {
                    this.$router.replace({ name: "gallery-cart" });
                    return;
                }

                this.checkoutSummary = result.summary;
                this.deliveryTypes = result.deliveryTypes;
                this.setPageTitle();

                if (
                    Object.prototype.hasOwnProperty.call(
                        this.deliveryTypes,
                        "shop"
                    )
                ) {
                    this.deliveryTypeKey = "shop";
                } else {
                    this.deliveryTypeKey = "home";
                }
                this.checkoutUser = result.user;

                if (!this.checkoutUser.email) {
                    this.checkoutUser.isNew = true;
                    // Caso utente non registrato: si recupera la mail associata al token
                    var userState = this.$store.getters.userState;
                    if (userState && userState.email) {
                        this.checkoutUser.email = userState.email;
                    }
                    this.checkoutUser.state = "Italia";
                } else {
                    // Caso utente registrato
                    this.checkoutUser.isNew = false;
                    // controlla info in localstorage, se email corrisponde e timestamp è valido allora non mostra la popup
                    var userData = this.$store.getters.userData;
                    this.showAuthPopup =
                        !this.$store.getters.isUserDataValid ||
                        (userData &&
                            this.checkoutUser.email !== userData.email);
                    //this.showAuthPopup = true;
                    this.loginUsername = this.checkoutUser.email;
                    this.loginPassword = "";
                }

                console.debug("LOGINUSERNAME", this.loginUsername);

                this.lastCheckoutMail = this.checkoutUser.email;
                this.gotoStepShippingAddress();
                this.$nextTick(() => {
                    this.onChangeCountry();
                });
            })
            .catch((error) => {
                console.error("GET_CHECKOUT_SUMMARY", error);
                this.gotoCart();
            })
            .finally();
        extend("required", {
            ...required,
            message: this.$t("Campo obbligatorio")
        });
        extend("email", {
            ...email,
            message: this.$t("Inserire una e-mail valida")
        });
        extend("confirmed", {
            ...confirmed,
            validate(value, { target }) {
                return String(value) === String(target);
            },
            message: this.$t("I campi devono coincidere")
        });
    },

    methods: {
        setPageTitle() {
            this.pageTitle = this.checkoutSummary.title
                ? this.checkoutSummary.title + " - Checkout"
                : "Checkout";
        },

        checkoutConfirm() {
            //this.checkoutBusy = true;
            this.updateCheckoutButtons();

            return new Promise((resolve, reject) => {
                if (!this.checkoutUser.isNew) {
                    // utente registrato => può proseguire con l'ordine
                    resolve();
                    return;
                }

                // utente non registrato => prima si registra, poi si fa l'ordine
                this.$api
                    .insertUser(
                        this.checkoutUser.email,
                        this.checkoutUser.password,
                        this.checkoutUser.lastName,
                        this.checkoutUser.firstName,
                        this.checkoutUser.address,
                        this.checkoutUser.postalCode,
                        this.checkoutUser.city,
                        this.checkoutUser.province,
                        this.checkoutUser.state,
                        this.checkoutUser.tel
                    )
                    .then((result) => {
                        this.$store.commit("UPDATE_TOKEN", result.token);
                        this.$store.commit("UPDATE_USER", result.user);
                        this.$store.commit(
                            "UPDATE_USER_STATE",
                            result.userState
                        );
                        this.$store.dispatch("UPDATE_USER_DATA", result.user);
                        resolve();
                    })
                    .catch(reject);
            })
                .then(() => {
                    var shippingData = {};
                    var paymentData = { type: this.paymentTypeKey };
                    var invoiceData = {};
                    if (this.flagFattura || this.isInvoiceRequired) {
                        if (this.userInvoiceData) {
                            invoiceData = this.userInvoiceData;
                        }
                    }

                    switch (this.deliveryTypeKey) {
                        case "home":
                            shippingData = {
                                type: this.deliveryTypeKey,
                                cost: this.getShippingCost(this.paymentTypeKey),
                                firstName: this.checkoutUser.firstName,
                                lastName: this.checkoutUser.lastName,
                                address: this.checkoutUser.address,
                                zip: this.checkoutUser.postalCode,
                                city: this.checkoutUser.city,
                                province: this.checkoutUser.province,
                                country: this.checkoutUser.state,
                                tel: this.checkoutUser.tel
                            };
                            break;

                        case "shop":
                        default:
                            shippingData = {
                                type: this.deliveryTypeKey,
                                cost: this.getShippingCost(this.paymentTypeKey)
                            };
                            break;
                    }

                    this.$api
                        .createOrder(
                            this.checkoutUser,
                            shippingData,
                            paymentData,
                            invoiceData
                        )
                        .then((result) => {
                            // se pagamento fido fa redirect alla pagina order-confirm
                            // se pagamento paypal fa submit form paypal per pagamento
                            console.debug("CREATE_ORDER", result);
                            var resultOrder = result.order;
                            this.$store.getters.userState.numCartItems = 0;

                            switch (this.paymentTypeKey) {
                                case "paypal":
                                    if (result.paypalData) {
                                        this.$refs.paypalForm.action =
                                            process.env.VUE_APP_PAYPAL_ENDPOINT;
                                        this.$refs.paypalForm.business.value =
                                            result.paypalData.accountEmail;
                                        this.$refs.paypalForm.amount.value =
                                            resultOrder.total;

                                        this.$refs.paypalForm.return.value =
                                            window.location.origin +
                                            this.$router.resolve({
                                                name: "gallery-order-confirm",
                                                params: {
                                                    galleryUrl:
                                                        this.$route.params
                                                            .galleryUrl,
                                                    orderId: resultOrder.orderId
                                                }
                                            }).href;
                                        this.$refs.paypalForm.cancel_return.value =
                                            window.location.origin +
                                            this.$router.resolve({
                                                name: "gallery-account-orders"
                                            }).href;
                                        this.$refs.paypalForm.notify_url.value =
                                            result.paypalData.notifyUrl;
                                        this.$refs.paypalForm.item_number.value =
                                            result.paypalData.itemNumber;
                                        this.$refs.paypalForm.submit();
                                    }
                                    break;

                                case "cash":
                                default:
                                    this.$router.push({
                                        name: "gallery-order-confirm",
                                        params: {
                                            galleryUrl:
                                                this.$route.params.galleryUrl,
                                            orderId: resultOrder.orderId
                                        }
                                    });
                                    break;
                            }
                            // se paypal
                        })
                        .catch((error) => {
                            console.error("CREATE_ORDER", error);
                            this.updateCheckoutButtons(true);
                            var message = "Impossibile concludere l'ordine";
                            if (typeof error === "object" && error.message) {
                                if (error.message.includes("extra fido")) {
                                    message +=
                                        " (ordine extra fido). Contattare il fotografo.";
                                }
                            }
                            this.checkoutError = message;
                        });
                })
                .catch((error) => {
                    console.error("ERROR", error);
                    // TODO: mostrare avviso x errore in creazione utente
                    this.updateCheckoutButtons(true);
                });
        },

        checkUser() {
            this.checkoutBusy = true;

            return this.$api
                .checkUser(this.checkoutUser.email)
                .then((result) => {
                    console.log("CHECKUSER", result);
                    // la mail inserita esiste (utente esistente)
                    this.checkoutBusy = false;
                    this.checkoutUser.isNew = false;

                    if (this.checkoutUser.email != this.lastCheckoutMail) {
                        var userData = this.$store.getters.userData;
                        this.showAuthPopup =
                            userData &&
                            userData.email !== this.checkoutUser.email;

                        this.$store.dispatch(
                            "UPDATE_USER_DATA",
                            this.checkoutUser
                        );

                        //this.showAuthPopup = true;
                        this.lastCheckoutMail = this.checkoutUser.email;
                        this.loginUsername = this.lastCheckoutMail;
                        this.loginPassword = "";
                        return true;
                    }

                    // può continuare il submit
                    return false;
                })
                .catch((error) => {
                    console.warn("CHECKUSER", error);
                    // la mail inserita non esiste (nuovo utente) => bisogna fargli riempire la password (registrazione)
                    this.checkoutBusy = false;

                    // Ripristina un guest con la mail inserita e marca l'utente come nuovo, ferma eventuale submit
                    if (this.checkoutUser.email != this.lastCheckoutMail) {
                        this.$store.dispatch(
                            "UPDATE_USER_DATA",
                            this.checkoutUser
                        );

                        var guestMail = this.checkoutUser.email;
                        this.checkoutUser = {};
                        this.checkoutUser.email = guestMail;
                        this.checkoutUser.isNew = true;
                        this.lastCheckoutMail = guestMail;
                        return true;
                    }

                    // può continuare il submit
                    return false;
                });
        },

        checkValidUserForm: function () {
            if (this.$refs.checkUserForm.checkValidity()) {
                return true;
            }

            if (typeof this.$refs.checkUserForm.reportValidity == "function") {
                this.$refs.checkUserForm.reportValidity();
            } else {
                var btn = document.createElement("button");
                this.$refs.checkUserForm.appendChild(btn);
                btn.click();
                this.$refs.checkUserForm.removeChild(btn);
            }

            return false;
        },

        getMinDeliveryPrice: function (deliveryType) {
            var paymentTypes = this.deliveryTypes[deliveryType].paymentTypes;
            var first = true;
            var min = 0;
            for (var paymentType in paymentTypes) {
                var paymentTypeData = paymentTypes[paymentType];
                var deliveryCost = paymentTypeData.deliveryCost;
                if (typeof deliveryCost === "string") {
                    deliveryCost = deliveryCost.replace(",", ".");
                }
                deliveryCost = parseFloat(deliveryCost);
                if (first || deliveryCost < min) {
                    min = deliveryCost;
                    first = false;
                }
            }

            return min;
        },

        getSubTotal(paymentType) {
            return parseFloat(this.checkoutSummary.subTotal);
        },

        getShippingCost(paymentType) {
            var paymentTypes =
                this.deliveryTypes[this.deliveryTypeKey].paymentTypes;
            return parseFloat(paymentTypes[paymentType].deliveryCost);
        },

        getTotal(paymentType) {
            var paymentTypes =
                this.deliveryTypes[this.deliveryTypeKey].paymentTypes;
            var shippingCost = parseFloat(
                paymentTypes[paymentType].deliveryCost
            );
            var subTotal = parseFloat(this.checkoutSummary.subTotal);
            return subTotal + shippingCost;
        },

        getPaypalUrl() {
            return process.env.VUE_APP_PAYPAL_ENDPOINT;
        },

        updateCheckoutButtons(reset = false) {
            this.checkoutError = "";
            if (reset) {
                this.checkoutBusy = false;
                this.cashCheckout = false;
                this.paypalCheckout = false;
            } else {
                this.checkoutBusy = true;
                this.cashCheckout =
                    this.paymentTypeKey === "cash" ? true : false;
                this.paypalCheckout =
                    this.paymentTypeKey === "cash" ? false : true;
            }
        },

        onCashSubmit() {
            this.setPaymentType("cash");
            this.checkoutConfirm();
        },

        async onPaypalSubmit() {
            let valid = false;
            if (
                (this.flagFattura || this.isInvoiceRequired) &&
                this.$refs["user-invoice-form"]
            ) {
                valid = await this.$refs["user-invoice-form"].validate();
            } else {
                valid = true;
            }
            if (valid) {
                this.setPaymentType("paypal");
                this.checkoutConfirm();
            } else {
                this.gotoFirstInvalidField();
            }
        },

        async onMobileSubmit() {
            let valid = false;
            if (
                this.paymentTypeKey === "paypal" &&
                (this.flagFattura || this.isInvoiceRequired)
            ) {
                valid = await this.$refs["user-invoice-form"].validate();
            } else {
                valid = true;
            }
            if (valid) {
                this.checkoutConfirm();
            } else {
                this.gotoFirstInvalidField();
            }
        },

        gotoCart: function () {
            this.$router.push({
                name: "gallery-cart",
                params: {
                    galleryUrl: this.$route.params.galleryUrl
                }
            });
        },

        gotoDeliveryMode: function () {
            // Validazione form - con api Html5 al momento
            /*if (!this.checkValidUserForm()) {
                return;
            }*/

            this.checkUser()
                .then((stopCheckout) => {
                    console.debug("CHECKUSER", stopCheckout);
                    if (!stopCheckout) {
                        if (
                            this.userInvoiceData &&
                            Object.keys(this.userInvoiceData).length === 0 &&
                            this.userInvoiceData.constructor === Object
                        ) {
                            this.invoiceCitiesList = this.citiesList;
                            this.invoiceZipList = this.zipList;
                            this.onRequireInvoice();
                        }
                        this.checkoutStep = CHECKOUT_STEP_DELIVERY_MODE;
                    }
                })
                .catch((error) => {
                    console.error("CHECKUSER", error);
                });
        },

        gotoPaymentMode: async function (deliveryType) {
            let valid = false;
            if (
                deliveryType === "home" &&
                (this.flagFattura || this.isInvoiceRequired)
            ) {
                valid = await this.$refs["user-invoice-form"].validate();
            } else {
                valid = true;
            }
            if (valid) {
                this.deliveryTypeKey = deliveryType;
                if (this.hasPaymentType("cash")) {
                    this.paymentTypeKey = "cash";
                } else if (this.hasPaymentType("paypal")) {
                    this.paymentTypeKey = "paypal";
                }
                this.gotoStepPaymentMode();
            } else {
                this.gotoFirstInvalidField();
            }
        },

        gotoFirstInvalidField() {
            let el = document.querySelector(".text-danger");
            el.scrollIntoView();
        },

        /*gotoAskConfirm(paymentType) {
            alert("METODO gotoAskConfirm DA RIMUOVERE");
            this.paymentTypeKey = paymentType;
            this.gotoStepAskConfirm();
        },*/

        navigateSteps() {
            if (this.isStepShippingAddress) {
                this.gotoCart();
            }
            if (this.isStepDeliveryMode) {
                this.gotoStepShippingAddress();
            }
            if (this.isStepPaymentMode) {
                this.gotoStepDeliveryMode();
            }
        },

        gotoStepShippingAddress() {
            this.checkoutStep = CHECKOUT_STEP_SHIPPING_ADDRESS;
        },

        gotoStepDeliveryMode() {
            this.checkoutStep = CHECKOUT_STEP_DELIVERY_MODE;
        },

        gotoStepPaymentMode() {
            this.cashCheckout = false;
            this.paypalCheckout = false;
            this.checkoutStep = CHECKOUT_STEP_PAYMENT_MODE;
        },

        /*gotoStepAskConfirm() {
            alert("METODO gotoStepAskConfirm DA RIMUOVERE");
            this.checkoutStep = CHECKOUT_STEP_ASK_CONFIRM;
        },*/

        hasDeliveryType: function (deliveryTypeKey) {
            return Object.prototype.hasOwnProperty.call(
                this.deliveryTypes,
                deliveryTypeKey
            );
        },

        hasPaymentType(paymentType) {
            return this.deliveryTypes &&
                this.deliveryTypes[this.deliveryTypeKey] &&
                this.deliveryTypes[this.deliveryTypeKey].paymentTypes &&
                this.deliveryTypes[this.deliveryTypeKey].paymentTypes[
                    paymentType
                ]
                ? true
                : false;
        },

        onUserLoginClose() {
            this.showAuthPopup = false;
            if (this.isPrivateEvent) {
                // torna al carrello
                this.navigateSteps();
            } else {
                this.lastCheckoutMail = "";
                this.checkoutUser = {};
                this.checkoutUser.isNew = true;
            }
        },

        onUserLogin(loginData) {
            this.$store.dispatch("UPDATE_USER_LOGIN", loginData);
            this.checkoutUser = loginData.user;
            this.checkoutUser.isNew = false;
            this.lastCheckoutMail = this.checkoutUser.email;
            this.showAuthPopup = false;
        },

        resetValidateLoginPwdError() {
            this.validateLoginPwdError = false;
        },

        sendRecoveryPassword: function () {
            this.authBusy = true;

            return this.$api
                .resetPassword(this.loginUsername)
                .then(() => {
                    this.authBusy = false;
                    this.recoveryPasswordSent = true;
                })
                .catch((error) => {
                    //TODO fare il popup con errore
                    alert("Ricorda password: errore. Riprovare");
                    console.error(error);
                    this.authBusy = false;
                });
        },

        setPaymentType(paymentType) {
            this.paymentTypeKey = paymentType;
            if (
                this.deliveryTypeKey == "shop" &&
                paymentType == "cash" &&
                !this.isInvoiceRequired
            ) {
                this.flagFattura = false;
            }
        },

        setDeliveryType(deliveryType) {
            this.deliveryTypeKey = deliveryType;
            if (deliveryType == "shop" && !this.isInvoiceRequired) {
                this.flagFattura = false;
            }
        },

        showPasswordForgotInfo: function () {
            this.showPasswordForgot = true;
        },

        onChangeCountry() {
            this.$refs.province.disabled = true;
            this.$refs.city.disabled = true;
            this.$refs.zip.disabled = true;
            this.$api
                .getItalyProvinces()
                .then((result) => {
                    console.debug("GET_ITALY_PROVINCES", result);
                    this.provincesList = result.provinces;
                    this.onChangeProvince();
                    this.$refs.province.disabled = false;
                    this.$refs.city.disabled = false;
                    this.$refs.zip.disabled = false;
                })
                .catch((error) => {
                    console.error("GET_ITALY_PROVINCES", error);
                    alert("Si è verificato un errore. Riprovare più tardi.");
                    this.$router.push({
                        name: this.$route.meta.gotoOnAuthFailed,
                        params: this.$route.params
                    });
                });
        },

        onChangeProvince() {
            this.$refs.province.disabled = true;
            this.$refs.city.disabled = true;
            this.$refs.zip.disabled = true;
            this.$api
                .getItalyCities(this.checkoutUser.province)
                .then((result) => {
                    console.debug("GET_ITALY_CITIES", result);
                    this.citiesList = result.cities;
                    if (
                        !this.citiesList ||
                        !this.citiesList[this.checkoutUser.city]
                    ) {
                        this.checkoutUser.city = "";
                    }
                    this.onChangeCity();
                    this.$refs.province.disabled = false;
                    this.$refs.city.disabled = false;
                    this.$refs.zip.disabled = false;
                })
                .catch((error) => {
                    console.error("GET_ITALY_CITIES", error);
                    this.$router.push({
                        name: this.$route.meta.gotoOnAuthFailed,
                        params: this.$route.params
                    });
                });
        },

        onChangeCity() {
            if (this.citiesList[this.checkoutUser.city]) {
                this.zipList = this.citiesList[this.checkoutUser.city];
                if (
                    this.zipList.filter((zip) => {
                        return zip.cap === this.checkoutUser.postalCode;
                    }).length === 0
                ) {
                    this.checkoutUser.postalCode = "";
                }
            } else {
                this.zipList = [];
                this.checkoutUser.postalCode = "";
            }
            /*this.zipList = this.citiesList[this.checkoutUser.city]
                ? this.citiesList[this.checkoutUser.city]
                : [];*/
        },

        setConsent(consentType) {
            if (consentType === "terms") {
                this.flagTerms = !this.flagTerms;
            }
            if (consentType === "marketing") {
                this.flagMarketing = !this.flagMarketing;
            }
        },

        onShowTerms() {
            this.$refs.footer.onShowTerms();
        },

        onShowPrivacy() {
            this.$refs.footer.onShowPrivacy();
        },

        onRequireInvoice() {
            if (!this.isInvoiceRequired) {
                this.flagFattura = !this.flagFattura;
            }
            if (
                this.userInvoiceData &&
                Object.keys(this.userInvoiceData).length === 0 &&
                this.userInvoiceData.constructor === Object
            ) {
                this.userInvoiceData =
                    this.isInvoiceRequired || this.flagFattura
                        ? {
                              invoiceType: "person",
                              ragioneSociale:
                                  this.checkoutUser.lastName +
                                  " " +
                                  this.checkoutUser.firstName,
                              codiceFiscale: "",
                              piva: "",
                              codiceIdentificativo: "",
                              pec: "",
                              nazione: this.checkoutUser.state,
                              provincia: this.checkoutUser.province,
                              citta: this.checkoutUser.city,
                              cap: this.checkoutUser.postalCode,
                              indirizzo: this.checkoutUser.address,
                              tel: this.checkoutUser.tel
                          }
                        : {};
            }
        }
    },

    computed: {
        isStepLoading() {
            return this.checkoutStep == CHECKOUT_STEP_LOADING_CHECKOUT_DATA;
        },
        isStepOrderConfirmed() {
            return this.checkoutStep == CHECKOUT_STEP_ORDER_CONFIRMED;
        },
        isStepShippingAddress() {
            return this.checkoutStep == CHECKOUT_STEP_SHIPPING_ADDRESS;
        },
        isStepDeliveryMode() {
            return this.checkoutStep == CHECKOUT_STEP_DELIVERY_MODE;
        },
        isStepPaymentMode() {
            return this.checkoutStep == CHECKOUT_STEP_PAYMENT_MODE;
        },
        isStepAskConfirm() {
            return this.checkoutStep == CHECKOUT_STEP_ASK_CONFIRM;
        },

        shopHasOnlinePayment() {
            return (
                this.deliveryTypes.shop &&
                this.deliveryTypes.shop.paymentTypes.paypal
            );
        },
        deliveryLabel() {
            var createdOrder = this.createdOrder;
            var label = "";
            if (createdOrder && createdOrder.shippingType) {
                if (createdOrder.shippingType == "F") {
                    label = this.$t("Ritiro in negozio");
                } else if (createdOrder.shippingType == "D") {
                    label = this.$t("Consegna a domicilio");
                }
            }
            return label;
        },
        numCartItems() {
            var userState = this.$store.getters.userState;
            return userState && userState.numCartItems
                ? userState.numCartItems
                : 0;
        },

        isPrivateEvent() {
            return this.$store.getters.isPrivateEvent;
        },

        isVisitor() {
            return this.$store.getters.isVisitor;
        },

        isInvoiceRequired() {
            return this.$store.getters.eventData.eventFlagInvoice;
        }

        /*isMobile() {
            return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        }*/
    }
};
</script>

<style scoped>
@-webkit-keyframes loadingAnimation {
    0% {
        opacity: 0;
    }

    20% {
        opacity: 0.2;
    }

    40% {
        opacity: 0.4;
    }

    60% {
        opacity: 0.6;
    }

    80% {
        opacity: 0.8;
    }

    100% {
        opacity: 1;
    }
}

@keyframes loadingAnimation {
    0% {
        opacity: 0;
    }

    20% {
        opacity: 0.2;
    }

    40% {
        opacity: 0.4;
    }

    60% {
        opacity: 0.6;
    }

    80% {
        opacity: 0.8;
    }

    100% {
        opacity: 1;
    }
}

.loading-indicator {
    margin: 40px 0;
    text-align: center;
}

.loading-indicator .loading-square {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 8px;
    -webkit-animation: loadingAnimation 0.8s ease-in-out infinite;
    animation: loadingAnimation 0.8s ease-in-out infinite;
    /*background-color: #49A1D0;*/
    background-color: var(--tiffany);
}

.loading-indicator .loading-square:nth-child(1) {
    -webkit-animation-delay: 0;
    animation-delay: 0;
}

.loading-indicator .loading-square:nth-child(2) {
    -webkit-animation-delay: 0.1s;
    animation-delay: 0.1s;
}

.loading-indicator .loading-square:nth-child(3) {
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
}

.loading-indicator .loading-square:nth-child(4) {
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
}

.loading-indicator .loading-square:nth-child(5) {
    -webkit-animation-delay: 0.4s;
    animation-delay: 0.4s;
    margin-right: 0;
}

.visualizzazione-checkout .form-container .btn[disabled],
.visualizzazione-checkout .form-container input[disabled] {
    cursor: not-allowed;
}
/*
#checkout .popup {
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    background: rgba(255, 255, 255, 0.9);
    max-width: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 200000;
    position: fixed;
    top: 0;
    right: 0;
    padding-left: 1rem;
}

#checkout .popup .navbar {
    background: transparent;
}

#checkout .popup footer {
    height: 33px;
}

#checkout .navbar .close,
#checkout .navbar .close:hover,
#checkout .navbar .close:focus {
    color: rgb(0, 0, 0);
}*/

#checkout .justify-content-center.text-uppercase {
    width: 100%;
}

#checkout .justify-content-center.text-uppercase h5 {
    margin: 0;
}

#checkout .deliveryInfo {
    margin-bottom: 10px;
}

#checkout .shippingAddress {
    margin: 10px 0;
}

#checkout .deliveryChoiceBlock {
    background-color: var(--tiffany);
    color: white;
    padding: 20px;
    border-radius: 1em;
    font-size: 120%;
}

#checkout .custom-control-input:checked ~ .custom-control-label::before {
    border-color: var(--blu-chiaro);
    background-color: var(--blu-chiaro);
}

#checkout .deliveryDateInfo,
#checkout .deliveryTableLabel {
    color: var(--tiffany);
    font-weight: bold;
}
</style>
